// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__zVRzd","plus":"styles_plus__TRB97","key":"styles_key__ysmsC"};